import { gql } from '@apollo/client';
import { NEW_COMMUNICATION } from '../fragments/communications';
import { NEW_ORDER } from '../fragments/orders';

// CREATE_NEW_COMMUNICATION, UPDATE_COMMUNICATION eliminados
// (Bloque C-Limpieza 2026-05-08): sustituidos por SAVE_COMMUNICATION atómica.

/**
 * Endpoint unificado que reemplaza CREATE_NEW_ORDER + CREATE_NEW_COMMUNICATION +
 * UPDATE_ORDER + UPDATE_COMMUNICATION + UPDATE_ORDER_RELATIONSHIPS de los flujos
 * NewComunication/DuplicateComunication/EditCommunication.
 * Ver PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 */
export const SAVE_COMMUNICATION = gql`
  mutation SaveCommunication($input: SaveCommunicationInput!) {
    saveCommunication(input: $input) {
      order {
        ...NewOrder
      }
      communication {
        ...NewCommunication
      }
    }
  }
  ${NEW_ORDER}
  ${NEW_COMMUNICATION}
`;
